export const RESET_WEEK_RESERVATIONS = 'RESET_WEEK_RESERVATIONS'
export const SET_WEEK_RESERVATION = 'SET_WEEK_RESERVATION'
export const DELETE_WEEK_RESERVATION = 'DELETE_WEEK_RESERVATION'
